<div style="position: relative; min-height: 630px" >
  <div class="alert alert-danger mb-2" role="alert" *ngIf="mensagemErro">
    <i class="fas fa-exclamation-triangle"></i> {{mensagemErro}}
  </div>
  <div id="load" [hidden]="renderizou"  ></div>
  <div id="cardPaymentBrick_container" ></div>
</div>
